import { OWAConnectedAccount } from './schema/OWAConnectedAccount';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import './mutators/accountsMapMutators';

export default createStore('OWAAccountsStore', {
    accountsMap: new ObservableMap<string, OWAConnectedAccount>({}),
});
